exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bestline-box[data-v-d167fce0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -ms-flex-line-pack: start;\n      align-content: flex-start;\n}\n.move[data-v-d167fce0] {\n  margin: 0px;\n  padding: 2px 4px;\n  line-height: 20px;\n  border: 1px solid transparent;\n  border-radius: 0px;\n}\n.move[data-v-d167fce0]:hover {\n  background-color: #aed6f1;\n}\n", ""]);

// exports
